import { render, staticRenderFns } from "./PhysicalEffort.vue?vue&type=template&id=f097047e&scoped=true&"
import script from "./PhysicalEffort.vue?vue&type=script&lang=js&"
export * from "./PhysicalEffort.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalEffort.vue?vue&type=style&index=0&id=f097047e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f097047e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
